import styled from '../../../../styles/styledComponents/themeComponents';

export const SelectListModalStyle = styled.div`
  ._amondz-table-summary {
    display: none;
  }

  ._amondz-table {
    .ant-table-body {
      max-height: 545px;
    }
  }

  .ellipsis {
    ${(props) => props.theme.ellipsis}
  }
`;
